/* eslint-disable */
export function calculateTravelZips(profile = {}, canEditProfile) {
  const {
    points = [],
    travelZips = [],
    zipEntryType = 'map',
  } = profile;

  if ((zipEntryType === 'map') && canEditProfile) {
    let includeZips = [];
    let excludeZips = [];
    points.forEach(point => {
      if (point.include) includeZips = [ ...includeZips, ...(point.zips || []) ];
      if (!point.include) excludeZips = [ ...excludeZips, ...(point.zips || []) ];
    });
    return includeZips.filter(zip => !excludeZips.includes(zip));
  } 

  return travelZips;
}
